import { api, responseErrorCheck, ShippingParcel, Shippings } from 'stylewhere/api'
import { ShippingOperationConfig } from 'stylewhere/shared'
import { handleDownload } from 'stylewhere/utils'

const ACTION_CODE_PARCEL_LABEL_PDF = 'PARCEL_LABEL_PDF'

export const downloadParcelLabelPdf = async (
  operation: ShippingOperationConfig,
  parcel: ShippingParcel,
  productionOrderRowId: string
): Promise<void> => {
  const pdf = await api
    .post(
      `${Shippings.getOperationEndpoint(operation)}/${parcel.id}/executeAction`,
      { operationId: operation.id, actionCode: ACTION_CODE_PARCEL_LABEL_PDF, attributes: { productionOrderRowId } },
      { responseType: 'blob' }
    )
    .then(responseErrorCheck)

  handleDownload(`${parcel.code}.pdf`, pdf as Blob, 'application/pdf')
}
